/**
 * Required mark component script class
 *
 * @package    Common
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React from 'react';

export default function RequiredMark() {
    return <span className="required-mark">*</span>;
}



// WEBPACK FOOTER //
// ./src/common/Form/RequiredMark.jsx